import React, { ReactNode } from 'react';
import { LoadingErrorState } from '../ErrorState';
import { Page, PageProps } from '@wix/design-system';
import { PageErrorStateIllustration } from './PageErrorStateIllustration';

export interface PageErrorStateProps extends PageProps {
  /**
   * Function, which will be executed on `Try Again` click.
   */
  onRetry: () => void;
  /**
   * Error state title
   */
  title: string;
  /**
   * Error state subtitle
   */
  subtitle: string;
  /**
   * Error state `Try Again` button text
   */
  retryText: string;
  /**
   * Error state image
   */
  image?: ReactNode;
}

export function PageErrorState({
  onRetry,
  title,
  subtitle,
  retryText,
  image,
  dataHook,
}: PageErrorStateProps) {
  return (
    <Page dataHook={dataHook}>
      <Page.Header />
      <Page.Content>
        <LoadingErrorState
          title={title}
          subtitle={subtitle}
          retryText={retryText}
          image={image ?? <PageErrorStateIllustration />}
          dataHook="page-error-state"
          onRetry={onRetry}
        />
      </Page.Content>
    </Page>
  );
}
